import { render, staticRenderFns } from "./Vote.vue?vue&type=template&id=6db54ca0&scoped=true"
import script from "./Vote.vue?vue&type=script&lang=js"
export * from "./Vote.vue?vue&type=script&lang=js"
import style0 from "./Vote.vue?vue&type=style&index=0&id=6db54ca0&prod&lang=scss"
import style1 from "./Vote.vue?vue&type=style&index=1&id=6db54ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db54ca0",
  null
  
)

export default component.exports